import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface BrindeFornecedor {
    id: number
    titulo: string
    descricao: string
    dataInicio: string | null
    dataFim: string | null
    numTipo: number
    tipoTexto: string
    disparado: boolean
    promocao: boolean
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaErroRaw = { codErro: number; mensagem?: string }

function isErroBackend(data: unknown): data is RespostaErroRaw {
    return (
        typeof data === "object" &&
        data !== null &&
        !Array.isArray(data) &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    )
}

function erroParaRespostaRaw(error: unknown): RespostaErroRaw {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    ) {
        const d = data as RespostaErroRaw
        return { codErro: d.codErro, mensagem: d.mensagem }
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" }
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" }
}

export const obterBrindesFornecedor = async function (
    authorization: string
): Promise<BrindeFornecedor[] | ErroApi> {
    try {
        const response = await api
            .get<BrindeFornecedor[] | RespostaErroRaw>("brinde/ObterBrindesFornecedor", {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) as RespostaErroRaw }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as BrindeFornecedor[]
    } catch (error) {
        RegistrarLogErro(error, "ObterBrindesFornecedor", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
